































import {Component, Watch, Mixins, Vue} from 'vue-property-decorator'
import {$, PageCollection} from 'simpli-web-sdk'
import {MixinFilter} from '@/components/mixins/MixinFilter'
import FilterDeliverySla from '@/components/filters/FilterDeliverySla.vue'
import DeliverySlaResponse from '@/model/response/DeliverySlaResponse'
import DeliverySlaRequest from '@/model/request/DeliverySlaRequest'
import {AppConfig} from '@/config/app.config'
import {snakeCase} from 'lodash'
import FilterToggle from '@/components/FilterToggle.vue'
import * as Helper from '@/helpers'
import moment from 'moment'

const metaInfo = () => ({
  title: $.t('view.reports.deliverySla.title'),
})

@Component({
  metaInfo,
  components: {FilterToggle, FilterDeliverySla},
})
export default class ReportsDeliverySlaView extends Mixins(MixinFilter) {
  filter = new DeliverySlaRequest()
  collection = new PageCollection(DeliverySlaResponse, this.filter, 10)

  AppConfig = AppConfig

  async created() {
    this.collection.orderBy = 'nome'
    this.collection.asc = true

    if (this.$route.query.from === undefined) {
      this.filter.fromDate = moment().startOf('month').format()
    }

    if (this.$route.query.to === undefined) {
      this.filter.toDate = moment().endOf('month').format()
    }
  }

  async downloadData(xlsx: boolean) {
    const reportEndpoint = '/user/indicador/entrega-sla/csv'

    if (!xlsx) {
        const csv = new PageCollection(DeliverySlaResponse, this.filter, null, null)
        csv.endpoint = reportEndpoint
        const fetch = async () => await csv.search()
        await $.await.run(fetch, 'download')
        csv.downloadCsv(snakeCase($.t('view.reports.deliverySla.title')))
    } else {
        await $.await.run(() => Helper.downloadXlsx(
          $.t('view.reports.deliverySla.title'),
          reportEndpoint,
          this.filter,
          DeliverySlaResponse,
          'DeliverySlaResponse',
          ), 'download')
    }
  }
}
